import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MarketplaceListing from '../../components/marketplace/MarketplaceListing';
import CreateProject from '../../components/marketplace/CreateProject';
import ProjectDetails from '../../components/marketplace/ProjectDetails';
import PurchaseCredits from '../../components/marketplace/PurchaseCredits';
import MyProjects from '../../components/marketplace/MyProjects';

const Marketplace = () => {
  const location = useLocation();
  
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<MarketplaceListing />} />
        <Route path="/create" element={<CreateProject />} />
        <Route path="/project/:id" element={<ProjectDetails />} />
        <Route path="/purchase/:id" element={<PurchaseCredits />} />
        <Route path="/my-projects" element={<MyProjects />} />
        <Route path="*" element={<Navigate to="/marketplace" replace />} />
      </Routes>
    </div>
  );
};

export default Marketplace;
